import { useSelector } from 'react-redux';

import { IMenu } from '../interfaces/menu';
import { IPartnersInfoResult } from '../interfaces/news';
import { ExtendedNewsOrg } from '../interfaces/organizations';
import { getOrganizations, getPartners, selectOrganizationMenuByAlias } from '../selectors/organizations';

export function useOrganizations(): { [key: string]: ExtendedNewsOrg } {
  return useSelector(getOrganizations);
}

export function usePartners(): IPartnersInfoResult {
  return useSelector(getPartners);
}

export function useOrganizationMenuByAlias(alias: string): IMenu[] {
  return useSelector(selectOrganizationMenuByAlias(alias));
}
